import type { components } from '@multaqa/api-client'
import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { localizedText } from '@/lib/me'

export type PaymentTermResource = components['schemas']['PaymentTermResource']

export function paymentTermLabel(
  terms: readonly PaymentTermResource[],
  termId: string | null,
  legacyText: string | null,
  locale: 'en' | 'ar',
): string {
  const term = terms.find((entry) => entry.id === termId)
  return (term ? localizedText(term.name, locale) : null) || legacyText || '—'
}

export function usePaymentTermOptions(companyId: string | null) {
  return useQuery<PaymentTermResource[], Error>({
    queryKey: ['companies', companyId, 'accounting', 'payment-terms'],
    enabled: Boolean(companyId),
    queryFn: async () => {
      if (!companyId) return []

      const response = (await api.GET('/accounting/payment-terms', {
        headers: { 'X-Company-Id': companyId },
      })) as {
        error?: { message?: string }
        data?: unknown
      }
      if (response.error) throw new Error(response.error.message ?? 'Failed to load payment terms')

      const outer = response.data as { data?: unknown } | undefined
      return (outer?.data ?? []) as PaymentTermResource[]
    },
  })
}
